<template>
  <div class="question" :class="{'border border-1 rounded-3': showBorder}">
    <div
      class="question-header d-flex justify-content-between align-items-center fst-italic text-success"
      :class="{'border-2 p-2': showBorder}"
      @click="toggleAnswer">
      <slot name="question">Question text missing!</slot>
      <i v-if="showCaret" :class="['caret', {'bi-caret-up-fill': isAnswerVisible, 'bi-caret-down-fill': !isAnswerVisible}]"></i>
    </div>
    <transition name="slide-fade">
      <div v-show="isAnswerVisible" class="answer-wrapper">
        <div class="question-answer" :class="{'px-2': showBorder}">
          <slot>Answer text missing!</slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const props = defineProps({
    showAnswer: { type: Boolean, default: false },
    showCaret: { type: Boolean, default: true },
    showBorder: { type: Boolean, default: true }
});

const isAnswerVisible = ref(props.showAnswer);

const toggleAnswer = () => {
  isAnswerVisible.value = !isAnswerVisible.value;
};
</script>

<style scoped>
.caret {
  cursor: pointer;
}

.slide-fade-enter-active, .slide-fade-leave-active {
  transition: max-height 1.5s ease, opacity 0.5s ease, transform 1.0s ease;
}

.slide-fade-enter-from, .slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-20px);
  max-height: 0;
}

.slide-fade-enter-to, .slide-fade-leave-from {
  opacity: 1;
  transform: translateY(0);
  max-height: 500px;
}

.answer-wrapper {
  overflow: hidden;
}
</style>
